import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useMediaQuery } from "@mui/material";

const HomeRemodeling = (props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        width: isMobile ? "88%" : "70%",
        paddingLeft: isMobile ? "30px" : "100px",
        height: isMobile ? "100%" : "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "28px",
          color: "#000000",
          marginBottom: "20px",
        }}
      >
        Chicago Home Remodeling Contractor
      </Typography>
      <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#000000" }}>
        Our specialties include kitchen and bathroom remodels, ADA bathroom
        remodeling, siding replacement, floor installations, garage renovations,
        window replacements, and interior and exterior painting. We also offer
        handyman home repair services. <br /> <br /> Serving Chicago area
        including: Chicago, Evanston, Skokie, Oak Park, Naperville, Schaumburg,
        Arlington Heights, Palatine, Des Plaines, Orland Park, Tinley Park,
        Cicero, Berwyn, and Oak Lawn. Let's build something amazing together!
        We’re here to create comfortable and practical spaces with our clients.
        Call (312) 636-1186 or email us to receive expert advice, an in-home
        design consultation, and a detailed estimate! Your satisfaction is 100%
        guaranteed.
      </Typography>
    </Box>
  );
};

HomeRemodeling.propTypes = {};

export default HomeRemodeling;
